/**
 * @generated SignedSource<<c25d836009e53730d30e5618cc707e50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespProductTileCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_user">;
  readonly " $fragmentType": "PdpRespProductTileCarousel_user";
};
export type PdpRespProductTileCarousel_user$key = {
  readonly " $data"?: PdpRespProductTileCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespProductTileCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespProductTileCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespRelatedItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5ba261d595ad6d099c6d9938374fff40";

export default node;
